import { createAction, props } from '@ngrx/store';

import { EntityFilters } from '@apps/prtg/models';
import { NoContentResult } from '@common/domain/models/no-content-result';

export const BackPrtgFiltersRequested = createAction(
    '[BACK-PRTG] Back Prtg Filters Requested'
);
export const BackPrtgFiltersSucceded = createAction(
    '[BACK-PRTG] Back Prtg Filters Succeded',
    props<{ filters: string[] }>()
);
export const BackPrtgFiltersFailed = createAction(
    '[BACK-PRTG] Back Prtg Filters Failed'
);

export const BackPrtgEntityFiltersCreateRequested = createAction(
    '[BACK-PRTG] Back Prtg EntityFilters Create Requested',
    props<{ entityFilters: EntityFilters }>()
);
export const BackPrtgEntityFiltersCreateSucceeded = createAction(
    '[BACK-PRTG] Back Prtg EntityFilters Create Succeeded'
);
export const BackPrtgEntityFiltersCreateFailed = createAction(
    '[BACK-PRTG] Back Prtg EntityFilters Create Failed'
);

export const BackPrtgEntityFiltersRetrieveRequested = createAction(
    '[BACK-PRTG] Back Prtg EntityFilters Retrieve Requested',
    props<{ entityId: string }>()
);
export const BackPrtgEntityFiltersRetrieveSucceeded = createAction(
    '[BACK-PRTG] Back Prtg EntityFilters Retrieve Succeded',
    props<{ result: NoContentResult<EntityFilters> }>()
);
export const BackPrtgEntityFiltersRetrieveFailed = createAction(
    '[BACK-PRTG] Back Prtg EntityFilters Retrieve Failed'
);

export const BackPrtgEntityFiltersUpdateRequested = createAction(
    '[BACK-PRTG] Back Prtg EntityFilters Update Requested',
    props<{ entityFilters: EntityFilters }>()
);
export const BackPrtgEntityFiltersUpdateSucceeded = createAction(
    '[BACK-PRTG] Back Prtg EntityFilters Update Succeeded'
);
export const BackPrtgEntityFiltersUpdateFailed = createAction(
    '[BACK-PRTG] Back Prtg EntityFilters Update Failed'
);

export const BackPrtgEntityFiltersDeleteRequested = createAction(
    '[BACK-PRTG] Back Prtg EntityFilters Delete Requested',
    props<{ entityId: string }>()
);
export const BackPrtgEntityFiltersDeleteSucceeded = createAction(
    '[BACK-PRTG] Back Prtg EntityFilters Delete Succeeded'
);
export const BackPrtgEntityFiltersDeleteFailed = createAction(
    '[BACK-PRTG] Back Prtg EntityFilters Delete Failed'
);

export const BackPrtgEntityFiltersCleaningRequested = createAction(
    '[BACK-PRTG] Back Prtg EntityFilters Cleaning Requested'
);
